<template>
  <div>
    <section class="pt-125 md:pt-175 lg:pt-200 mb-100">
      <div class="container">
        <div class="max-w-screen-xl mx-auto">
          <breadcrumb :breadcrumbs="[data?.entry].filter((b) => b)" />
        </div>
      </div>
    </section>

    <section
      id="contact"
      class="container my-50 lg:my-100"
    >
      <div class="max-w-screen-md mx-auto">
        <h1
          v-if="data?.entry?.heading"
          class="wysiwyg-title text-4xl md:text-5xl lg:text-6xl xl:text-7xl md:-ml-150 md:translate-x-150 text-primary-500"
          v-html="data.entry.heading"
        />
        <div
          v-if="data?.entry?.intro"
          class="mt-25 md:pr-50 lg:pr-100 text-lg wysiwyg"
          v-html="data.entry.intro"
        />

        <message :message="apiMessage" />

        <form
          class="flex flex-wrap md:-mx-25"
          @submit.prevent="sendForm"
        >
          <input
            type="hidden"
            name="action"
            value="contact-form/send"
          />
          <input
            type="hidden"
            name="subject"
            :value="data?.entry.title"
          />
          <input
            type="hidden"
            name="message[body]"
            :value="data?.entry.title"
          />

          <div class="w-full md:px-25 mt-50">
            <div class="text-secondary">
              <p class="text-xl font-bold">
                {{ $t('interior-advice.your-data') }}
              </p>
              <div class="relative mt-40">
                <input
                  id="name"
                  type="text"
                  class="form-input"
                  name="fromName"
                  :placeholder="`${$t('interior-advice.name')} *`"
                  required
                >
                <label
                  for="name"
                  class="form-label"
                >{{ $t('interior-advice.name') }} *</label>
              </div>
              <div class="relative mt-40">
                <input
                  id="email"
                  type="email"
                  class="form-input"
                  name="fromEmail"
                  :placeholder="`${$t('interior-advice.email')} *`"
                  required
                >
                <label
                  for="email"
                  class="form-label"
                >{{ $t('interior-advice.email') }} *</label>
              </div>
              <button
                type="submit"
                :class="[loading ? 'bg-primary-700' : 'bg-primary-300']"
                class="flex w-full text-xl lg:text-2xl px-30 py-20 mt-50 items-center justify-center space-x-10 text-white font-serif font-bold hover:bg-primary-500 transition"
              >
                <img
                  v-if="loading"
                  src="@/assets/img/icon-loader.png"
                  alt="loading..."
                  class="w-[30px] h-[30px] animate-spin"
                >
                {{ loading ? $t('interior-advice.sending') : $t('magazine.submit') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </section>

    <content-blocks :content-blocks="data?.entry?.contentBlocks" />
  </div>
</template>

<script setup>
import {
  useNuxtApp,
  useI18n,
  useAsyncGql,
  useSeo,
  ref,
  watch,
  $fetch,
} from '#imports';

// Data
const { $gtm } = useNuxtApp();
const { locale, t } = useI18n({ useScope: 'global' });
const variables = ref({ site: locale.value });
const { data } = await useAsyncGql('magazine', variables.value);

// Custom data
const apiMessage = ref(null);
const loading = ref(null);
const previews = ref([]);

// Watcher
watch(data, (value) => {
  if (value?.entry?.seomatic) {
    useSeo(value.entry.seomatic);
  }
}, { immediate: true });

/**
 * Sends contact form data
 *
 * @param {Event} e
 */
const sendForm = async (e) => {
  apiMessage.value = null;
  const body = new FormData(e.target);
  loading.value = true;

  try {
    await $fetch('/', {
      method: 'POST',
      body,
    });

    previews.value = [];
    e.target.reset();

    apiMessage.value = {
      error: false,
      message: t('contact.success'),
    };

    // GTM tracking
    $gtm.trackEvent({
      event: 'contact',
    });
  } catch (error) {
    apiMessage.value = {
      error: true,
      ...error.data,
    };
  } finally {
    loading.value = false;
  }
};
</script>
